import api from "./api";
import { i18n } from "../main";

export default {
  namespaced: true,
  state: () => ({
    action: { status: {}, error: {} },
    fees: {
      teams: 0,
      users: 0,
      designs: 0,
      k_requests: 0,
    },
    quota: {
      teams: { count: 0 },
      users: { count: 0 },
      designs: { count: 0 },
      k_requests: { count: 0 },
    },
    usage: {
      date_range: { start: null, end: null },
      teams: { highest_count: 0, count: 0 },
      users: { highest_count: 0, count: 0 },
      designs: { highest_count: 0, count: 0 },
      k_requests: { count: 0 },
    },
  }),
  mutations: {},
  actions: {
    async status({ commit, state, rootGetters, dispatch }, data) {
      state.action.status = { ...state.action.status, ...data };
    },
    async error({ commit, state, rootGetters, dispatch }, data) {
      state.action.error = { ...state.action.error, ...data };
    },
    async load({ commit, state, rootGetters, dispatch }, data) {
      try {
        await dispatch("status", { loading: "loading" });
        await dispatch("error", { loading: null });

        const data = (await api.get(`subscription`)).data;
        state.fees = data.fees;
        state.quota = data.quota;
        data.usage.k_requests.count = parseFloat(data.usage.k_requests.count.toFixed(2));
        state.usage = data.usage;

        await dispatch("status", { loading: "loaded" });

        return data;
      } catch (exp) {
        await dispatch("status", { loading: "loading-failed" });
        await dispatch("error", { loading: exp });

        if (exp.response.status != 404) {
          console.error(exp);

          dispatch(
            "addToast",
            {
              severity: "warn",
              life: 3000,
              ...i18n.global.tm("mybusiness.subscription.load.failed"),
            },
            { root: true }
          );
        }

        // throw exp;
      }
    },
    async update({ commit, state, rootGetters, dispatch }) {
      try {
        await dispatch("status", { updating: "updating" });
        await dispatch("error", { updating: null });

        await api.patch(`subscription`, state.quota);

        await dispatch("status", { updating: "updated" });
      } catch (exp) {
        await dispatch("status", { updating: "updating-failed" });
        await dispatch("error", { updating: exp });

        console.error(exp);

        dispatch(
          "addToast",
          {
            severity: "warn",
            life: 3000,
            ...i18n.global.tm("mybusiness.subscription.update.failed"),
          },
          { root: true }
        );

        // throw exp;
      }
    },
    async onboard({ commit, state, rootGetters, dispatch }, data) {
      try {
        await dispatch("status", { onboard: "onboard" });
        await dispatch("error", { onboard: null });

        await api.post(`onboard/${data.u_sub ? "guest" : "user"}`, data);

        await dispatch("status", { onboard: "onboarded" });
      } catch (exp) {
        await dispatch("status", { onboard: "onboard-failed" });
        await dispatch("error", { onboard: exp });

        console.error(exp);

        // throw exp;
      }
    },
  },
  getters: {},
};
